export const hasClientCursor = (): boolean => {
  return window.matchMedia("(pointer: fine)").matches;
};
